export const phoneRegExp = "^ *\\(?\\d{3}\\)?[- ]?\\d{3}[- ]?\\d{4} *$";
export const usPostalCodeRegExp = "^ *\\d{5}(?:-\\d{4})? *$";
export const caPostalCodeRegExp = "^ *[a-zA-Z]\\d[a-zA-Z] ?\\d[a-zA-Z]\\d *$";
export const caPostalCodeWithSpaceRegExp = "^.{3}[ ].{3}$";
